import { createAction, props } from '@ngrx/store';

import { BookmarkProblemsCollection, FindBookmarkProblemsParams } from '../models/bookmark-problem';

// お気に入り問題の検索 ----------------------------------------------------------------
export const findBookmarkProblems = createAction('[Bookmark Problems] Find Bookmark Problems', props<FindBookmarkProblemsParams>());
export const findBookmarkProblemsSuccess = createAction(
  '[Bookmark Problem List] Find Bookmark Problems Success',
  props<{ bookmarkProblems: BookmarkProblemsCollection[] }>()
);
export const findBookmarkProblemsFailure = createAction('[Bookmark Problems ] Find Bookmark Problems Failure');
export const initializeFindBookmarkProblemsState = createAction('[Bookmark Problems ] Initialize Find Bookmark Problems State');

// お気に入りリストに問題を登録する (ステートの操作) ------------------------------------------------------------
export const addProblem = createAction(
  '[Bookmark Problems] Add Problem',
  props<{ tempId: string; collectionData: BookmarkProblemsCollection }>()
);
export const addProblemSuccess = createAction('[Bookmark Problems] Add Problem Success');

// お気に入りリストへの問題登録APIが呼び出された後、実際のidを更新する (ステートの操作) -----------------------------
export const updateBookmarkProblemsId = createAction(
  '[Bookmark Problems] Update Bookamrk Problems Id',
  props<{ tempId: string; realId: string }>()
);
export const updateBookmarkProblemsIdSuccess = createAction('[Bookmark Problems] Update Bookmark Problems Id Success');

// お気に入りリストから問題を削除する (ステートの操作) ------------------------------------------------------------
export const deleteProblem = createAction('[Bookmark Problems] Delete Problem', props<{ listId: string; problemId: string }>());
export const deleteProblemSuccess = createAction('[Bookmark Problems] Delete Problem Success');
